<template>
  <div class="allBox">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="搜索"
        @search="searchHandle"
      />
    </div>

    <div v-if="already">
      <div style="height: 5px; background: #fff"></div>
      <div class="classifyNav">
        <van-tabs
          type="line"
          v-model="type"
          :ellipsis="amid ? false : auditState == 1 ? false : true"
          :color="amid ? '#3E69AF' : '#d62f2f'"
          :title-active-color="amid ? '#3E69AF' : '#d62f2f'"
          line-width="32px"
          line-height="5px"
          @change="typeClick"
        >
          <van-tab title="动态">
            <div class="blank-view"></div>
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getList"
            >
              <dynamic-list :list="list"></dynamic-list>
            </van-list>
            <div class="noDataBox" v-if="list.length == 0">
              <span class="iconfont icon-search"></span>
              <div>暂无内容，换个关键词试试吧</div>
            </div>
          </van-tab>
          <van-tab title="话题">
            <div class="blank-view"></div>
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getTopicList"
            >
              <div v-for="(item, index) in list" :key="index">
                <router-link
                  :to="{
                    path: '/hotTopicDetails',
                    query: { hid: item.TopicId },
                  }"
                >
                  <div class="topicItem">
                    <div class="ti_left">
                      <div class="tilTitle">#{{ item.TopicName }}#</div>
                      <div class="overFlowTwo">{{ item.TopicDesc }}</div>
                      <div class="times">
                        浏览次数：{{ item.Views }}次
                        <div>帖子数：{{ item.PostCount }}条</div>
                      </div>
                    </div>
                    <img :src="item.BackImage" class="tiImg" />
                  </div>
                </router-link></div
            ></van-list>
            <div class="noDataBox" v-if="list.length == 0">
              <span class="iconfont icon-search"></span>
              <div>暂无内容，换个关键词试试吧</div>
            </div>
          </van-tab>
          <div v-if="auditState == 1">
            <van-tab title="文章">
              <div class="blank-view"></div>
              <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="getArticleList"
              >
                <div
                  class="commonBox"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <!-- 样式一 -->
                  <div
                    class="common classThree"
                    v-if="item.CoverNum == 1"
                    @click="toArticleDetail(item.ContentID)"
                  >
                    <div class="classTitle">
                      {{ item.Title }}
                    </div>
                    <img class="imgItemThree" :src="item.Thumbnail" />
                  </div>
                  <!-- 样式二 -->
                  <div
                    class="common"
                    v-if="item.CoverNum == 3"
                    @click="toArticleDetail(item.ContentID)"
                  >
                    <div class="classTitle title">{{ item.Title }}</div>
                    <div class="imgBox">
                      <img
                        class="imgItem"
                        v-for="(inner, innerIndex) in item.ThumbnailList"
                        :key="innerIndex"
                        :src="inner"
                      />
                    </div>
                  </div>
                  <!-- 样式三 -->
                  <div
                    class="common"
                    v-if="item.CoverNum == 0"
                    @click="toArticleDetail(item.ContentID)"
                  >
                    <div class="classTitle title">{{ item.Title }}</div>
                  </div>
                </div>
              </van-list>
              <div class="noDataBox" v-if="list.length == 0">
                <span class="iconfont icon-search"></span>
                <div>暂无内容，换个关键词试试吧</div>
              </div></van-tab
            >
            <van-tab title="视频">
              <div class="blank-view"></div>
              <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="getVideoList"
              >
                <div v-for="(item, index) in list" :key="index">
                  <div class="l_item">
                    <div class="li_top">
                      <div class="avatarImg">
                        <van-image
                          fit="contain"
                          :src="item.Photo"
                          class="photo"
                          round
                          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
                        />
                        <div v-if="item.AuditState == 1">
                          <img
                            src="../../../static/images/index/attestation.png"
                            class="renzheng"
                            v-if="item.ExhibitionState == 1"
                          />
                          <img
                            src="../../../static/images/index/attestation01.png"
                            class="renzheng"
                            v-else
                          />
                        </div>
                      </div>
                      <div class="li_top_r">
                        <div>{{ item.Headline }}</div>
                        <div class="lrt_time">
                          {{ item.Times }}
                          <span v-if="item.Address" style="margin-left: 4px">
                            | {{ item.Address }}
                          </span>
                          <div v-if="item.IsExhibition">2022光亚展参展商</div>
                        </div>
                      </div>
                    </div>
                    <div class="li_mid" @click="toVideoDetail(item.VodId)">
                      <div class="text-box overFlowThree" v-if="item.Title">
                        {{ item.Title }}
                      </div>
                      <div class="video-box">
                        <van-image fit="cover" :src="item.CoverUrl"></van-image>
                        <div>
                          <span
                            class="iconfont icon-bofang"
                            style="color: #dddddd; font-size: 50px"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <!-- 底部操作项 -->
                    <div class="li_btm">
                      <van-row>
                        <van-col span="6" @click.stop="shareHandle">
                          <div
                            class="iconfont icon-share1"
                            style="font-size: 16px; margin-right: 4px"
                          ></div>
                          <div>分享</div></van-col
                        >
                        <van-col span="6">
                          <van-icon
                            name="eye-o"
                            size="18px"
                            style="margin-right: 4px"
                          /><span v-if="item.ClickUv">{{ item.ClickUv }}</span>
                        </van-col>
                        <van-col
                          span="6"
                          @click.stop="videoLikeChange(item.VodId, index)"
                        >
                          <van-icon
                            :name="item.IsLike ? 'like' : 'like-o'"
                            size="18px"
                            :color="item.IsLike ? '#d62f2f' : '#999'"
                            style="margin-right: 4px"
                          /><span v-if="item.LikeCount">{{
                            item.LikeCount
                          }}</span>
                        </van-col>
                        <van-col
                          span="6"
                          @click.stop="toVideoDetail(item.VodId)"
                        >
                          <span
                            class="iconfont icon-pinglun"
                            style="font-size: 15px; margin-right: 4px"
                          ></span
                          ><span v-if="item.Comment">{{ item.Comment }}</span>
                        </van-col>
                      </van-row>
                    </div>
                  </div>
                </div>
              </van-list>
              <div class="noDataBox" v-if="list.length == 0">
                <span class="iconfont icon-search"></span>
                <div>暂无内容，换个关键词试试吧</div>
              </div>
            </van-tab>
          </div>
          <div v-if="amid">
            <van-tab title="TA的推荐">
              <div class="blank-view"></div>
              <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="getTaList"
              >
                <div
                  class="recItem"
                  v-for="(item, index) in list"
                  :key="index"
                  @click.stop="toPathHandle(item.ID)"
                >
                  <div class="overFlowOne">{{ item.Subject }}</div>
                  <div>
                    <span>{{ item.AddTime }}</span
                    ><span>{{ item.Click }}浏览</span>
                  </div>
                </div>
              </van-list>
              <div class="noDataBox" v-if="list.length == 0">
                <span class="iconfont icon-search"></span>
                <div>暂无内容，换个关键词试试吧</div>
              </div>
            </van-tab>
          </div>
        </van-tabs>
      </div>
    </div>

    <div class="result-no" v-else>
      <span class="iconfont icon-search"></span>
      <div>搜索TA的动态、话题</div>
    </div>
    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <!--遮罩层-->
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import { articleList } from "@/api/article";
import { videoList, createVideoLike, cancelVideoLike } from "@/api/video";
import { memberInfo, memberPostList, memberTopicList } from "@/api/homepage";
import {
  Icon,
  Row,
  Col,
  Image,
  Overlay,
  List,
  Tab,
  Tabs,
  Toast,
  Search,
} from "vant";
import DynamicList from "@/components/dynamicList";
import { juryCommendArticleList } from "@/api/lighting";
import { formatTimeDay } from "@/utils/date";
export default {
  name: "searchHomepage",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-icon": Icon,
    "van-row": Row,
    "van-col": Col,
    "van-overlay": Overlay,
    "van-image": Image,
    "van-search": Search,
    DynamicList,
  },
  data() {
    return {
      mid: null,
      auditState: 0, //0普通会员 1认证会员 (头条号状态)
      exhibitionState: 0, //展厅状态-中文  1高级会员
      amid: null, //是否是评委

      keyword: "",
      already: false, //是否已点击查询

      type: 0, //0动态 1话题 文章 视频 TA的推荐
      tabTitle: "动态",

      delay: false, //延迟页面显示

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      showLayer: false,
    };
  },
  methods: {
    // 去除首尾的空格
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },

    //搜索
    searchHandle() {
      if (this.keyword == "") {
        Toast("请输入搜索内容");
        return false;
      }
      this.pageIndex = 1;
      this.already = true;
      this.list = [];
      this.loading = true;
      if (this.loading) {
        if (this.tabTitle == "动态") {
          this.getList();
        } else if (this.tabTitle == "话题") {
          this.getTopicList();
        } else if (this.tabTitle == "文章") {
          this.getArticleList();
        } else if (this.tabTitle == "视频") {
          this.getVideoList();
        } else if (this.tabTitle == "TA的推荐") {
          this.getTaList();
        } else {
        }
      }
    },

    //tab切换
    typeClick(name, title) {
      this.type = name;
      this.tabTitle = title;
      this.already = true;
      this.pageIndex = 1;
      this.list = [];
      if (this.tabTitle == "动态") {
        this.getList();
      } else if (this.tabTitle == "话题") {
        this.getTopicList();
      } else if (this.tabTitle == "文章") {
        this.getArticleList();
      } else if (this.tabTitle == "视频") {
        this.getVideoList();
      } else if (this.tabTitle == "TA的推荐") {
        this.getTaList();
      } else {
      }
    },

    //点赞操作
    videoLikeChange(id, index) {
      var newlist = this.list;
      if (newlist[index].IsLike) {
        cancelVideoLike({ VodId: id }).then((res) => {
          newlist[index].IsLike = false;
          newlist[index].LikeCount--;
        });
      } else {
        createVideoLike({ VodId: id }).then((res) => {
          newlist[index].IsLike = true;
          newlist[index].LikeCount++;
        });
      }
      this.list = newlist;
    },

    //获取会员状态
    getStatus() {
      var data = {
        MemberId: this.$route.query.mid,
      };
      memberInfo(data).then((res) => {
        this.info = res.Data;
      });
    },

    //删除用户动态
    trashClick(id) {
      var data = {
        PostId: id,
      };
      deleteMemberPost(data).then((res) => {
        Toast("删除成功");
        this.list = [];
        this.pageIndex = 1;
        this.getListHandle();
      });
    },

    //跳转视频详情
    toVideoDetail(id) {
      this.$router.push({
        path: "/videoDetail",
        query: { id: id },
      });
    },

    //跳转文章详情
    toArticleDetail(id) {
      this.$router.push({
        path: "/articleDetail",
        query: { id: id },
      });
    },

    //跳转推荐详情
    toPathHandle(id) {
      this.$router.push({
        path: "/recDetail",
        query: {
          id: id,
        },
      });
    },

    //获取动态列表
    getList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        MemberId: that.mid,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      memberPostList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //获取话题列表
    getTopicList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        MemberId: that.mid,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      memberTopicList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //获取文章列表
    getArticleList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        MemberId: that.mid,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      articleList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //获取视频列表
    getVideoList() {
      var that = this;
      var data = {
        Keyword: that.keyword,
        MemberId: that.mid,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      videoList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },

    //TA的推荐
    getTaList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        AwardYear: that.awardYear,
        AwardMemebrId: that.amid,
        Keyword: that.keyword,
      };
      juryCommendArticleList(data)
        .then((res) => {
          var list = res.Data.List;
          list.forEach((item, index) => {
            item.AddTime = formatTimeDay(item.AddTime, "-");
          });
          if (that.pageIndex == 1) {
            that.list = [...list];
          } else {
            that.list = [...that.list, ...list];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //分享好友
    shareHandle() {
      this.showLayer = true;
    },
  },

  mounted() {
    // this.getStatus();
    // if (this.$route.query.mid == localStorage.getItem("mid")) {
    //   this.edit = true;
    // } else {
    //   this.edit = false;
    // }
    this.mid = this.$route.query.mid;
    this.auditState = this.$route.query.state ? this.$route.query.state : 0;
    this.exhibitionState = this.$route.query.exhstate
      ? this.$route.query.exhstate
      : 0;
    this.amid = this.$route.query.amid ? this.$route.query.amid : null;
  },
};
</script>
<style scoped src="../../../static/css/searchpage.css"></style>
